/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetUserCouponPaymentsOptions,
  GetUserCouponPaymentsStatus200,
  GetUserCouponPaymentsStatus400,
  GetUserCouponPaymentsStatus404,
  GetUserCouponPaymentsStatus500,
} from '../types/GetUserCouponPayments'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getUserCouponPayments } from '../clients/getUserCouponPayments'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getUserCouponPaymentsQueryKey = ({
  path,
  query,
}: Omit<GetUserCouponPaymentsOptions, 'headers'>) =>
  [{ url: '/v1/user/:user_id/coupon_payments', params: path }, ...(query ? [query] : [])] as const

type GetUserCouponPaymentsQueryKey = ReturnType<typeof getUserCouponPaymentsQueryKey>

export function getUserCouponPaymentsQueryOptions(
  { path, query }: GetUserCouponPaymentsOptions,
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getUserCouponPaymentsQueryKey({ path, query })
  return queryOptions<
    GetUserCouponPaymentsStatus200,
    ResponseErrorConfig<
      | GetUserCouponPaymentsStatus400
      | GetUserCouponPaymentsStatus404
      | GetUserCouponPaymentsStatus500
    >,
    GetUserCouponPaymentsStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getUserCouponPayments({
        ...config,
        path,
        query,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary List coupon payments for a user
 * {@link /v1/user/:user_id/coupon_payments}
 */
export function useGetUserCouponPayments<
  TData = GetUserCouponPaymentsStatus200,
  TQueryData = GetUserCouponPaymentsStatus200,
  TQueryKey extends QueryKey = GetUserCouponPaymentsQueryKey,
>(
  {
    path,
    query,
  }: {
    path: GetUserCouponPaymentsOptions['path'] | (() => GetUserCouponPaymentsOptions['path'])
    query?: GetUserCouponPaymentsOptions['query'] | (() => GetUserCouponPaymentsOptions['query'])
  },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetUserCouponPaymentsStatus200,
        ResponseErrorConfig<
          | GetUserCouponPaymentsStatus400
          | GetUserCouponPaymentsStatus404
          | GetUserCouponPaymentsStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = {
    path: typeof path === 'function' ? path() : path,
    query: typeof query === 'function' ? query() : query,
  }
  const queryKey = resolvedOptions?.queryKey ?? getUserCouponPaymentsQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...getUserCouponPaymentsQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetUserCouponPaymentsStatus400
      | GetUserCouponPaymentsStatus404
      | GetUserCouponPaymentsStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
